import { render, staticRenderFns } from "./CrumbsBar.vue?vue&type=template&id=6a728826&scoped=true"
import script from "./CrumbsBar.vue?vue&type=script&lang=js"
export * from "./CrumbsBar.vue?vue&type=script&lang=js"
import style0 from "./CrumbsBar.vue?vue&type=style&index=0&id=6a728826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a728826",
  null
  
)

export default component.exports